var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, InputBase } from "@mui/material";
var UIInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, name = _a.name, placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? "text" : _b, inputMode = _a.inputMode, inputSx = _a.inputSx, sx = _a.sx, startAdornment = _a.startAdornment, endAdornment = _a.endAdornment, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.fullWidth, fullWidth = _d === void 0 ? true : _d, autoComplete = _a.autoComplete;
    return (_jsxs(Box, { sx: __assign(__assign({ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap", width: fullWidth ? "100%" : "auto", height: 32, px: 1.5, borderRadius: 1, gap: 1, bgcolor: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.12)", transition: "background-color 200ms ease, border-color 200ms ease" }, (disabled
            ? {
                opacity: 0.5,
                pointerEvents: "none",
            }
            : {
                "&:hover": {
                    bgcolor: "rgba(255,255,255,0.06)",
                    borderColor: "var(--accent-border)",
                },
            })), sx), children: [startAdornment, _jsx(InputBase, { disabled: disabled, value: value, type: type, onChange: function (e) { return onChange(e.target.value); }, placeholder: placeholder, name: name, inputMode: inputMode, autoComplete: autoComplete, sx: __assign({ width: "100%", minWidth: 0, fontFamily: "var(--default-font)", fontSize: 13, color: "rgba(255,255,255,0.92)", "& input": __assign({ padding: 0, backgroundColor: "transparent", "&::placeholder": {
                            color: "rgba(255,255,255,0.55)",
                            opacity: 1,
                        } }, (type === "number" && {
                        MozAppearance: "textfield",
                        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
                            WebkitAppearance: "none",
                            margin: 0,
                        },
                    })) }, inputSx) }), endAdornment] }));
};
export default UIInput;
